import { render, staticRenderFns } from "./AdditionalMenu.vue?vue&type=template&id=1cfb31b0&"
import script from "./AdditionalMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports